import { ReactNode } from "react";
import { Link } from "react-router";
import { useUserContext } from "../../../hooks/userContext";
import { Pages } from "../../../utils";

const ENHANCIFY_PROMO_URL =
  "https://www.enhancify.com/home-design-guild-2-promo";

interface AccessOfferLinkProps {
  className: string;
  children: ReactNode;
}

export const AccessOfferLink = ({ className, children }: AccessOfferLinkProps) => {
  const { user } = useUserContext();

  if (user?.id) {
    return (
      <a href={ENHANCIFY_PROMO_URL} className={className}>
        {children}
      </a>
    );
  }

  return (
    <Link to={Pages.LOGIN} className={className}>
      {children}
    </Link>
  );
};
